// Vertically-stacked social buttons rendered above the "social" pill on
// venue cards + preview sheets. Extracted from GuestMapSurface.js.

import React from 'react';
import { motion } from 'framer-motion';
import { actionButtonSurface } from './mapSurfaceStyles';

const WebsiteSvg = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
    <circle cx="12" cy="12" r="8" stroke="var(--accent-purple)" strokeWidth="2"/>
    <path d="M4 12H20" stroke="var(--accent-purple)" strokeWidth="2"/>
    <path d="M12 4C14 6.4 15 9 15 12C15 15 14 17.6 12 20C10 17.6 9 15 9 12C9 9 10 6.4 12 4Z" stroke="var(--accent-purple)" strokeWidth="2"/>
  </svg>
);

const InstagramSvg = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
    <rect x="3.1" y="3.1" width="17.8" height="17.8" rx="5.3" stroke="var(--accent-purple)" strokeWidth="2"/>
    <circle cx="12" cy="12" r="4.2" stroke="var(--accent-purple)" strokeWidth="2"/>
    <circle cx="17.4" cy="6.8" r="1.2" fill="var(--accent-purple)"/>
  </svg>
);

const FacebookSvg = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
    <path d="M13 21V12.7H15.8L16.2 9.8H13V7.95C13 7.07 13.25 6.5 14.46 6.5H16.3V3.88C15.96 3.83 14.98 3.74 13.84 3.74C11.4 3.74 9.7 5.24 9.7 8.05V9.8H7V12.7H9.7V21H13Z" fill="var(--accent-purple)"/>
  </svg>
);

const TiktokSvg = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
    <path d="M14.7 3C14.84 4.23 15.55 5.32 16.72 5.97C17.46 6.39 18.29 6.62 19.11 6.63V9.19C18.03 9.18 16.96 8.88 16.02 8.32V14.08C16.02 17.38 13.33 20.07 10.03 20.07C6.73 20.07 4.04 17.38 4.04 14.08C4.04 10.78 6.73 8.09 10.03 8.09C10.28 8.09 10.52 8.11 10.76 8.15V10.82C10.52 10.74 10.28 10.7 10.03 10.7C8.18 10.7 6.67 12.22 6.67 14.08C6.67 15.94 8.18 17.45 10.03 17.45C11.89 17.45 13.4 15.94 13.4 14.08V3H14.7Z" fill="var(--accent-purple)"/>
  </svg>
);

export function SocialPopup({ venue }) {
  const socials = [];
  if (venue.website) socials.push({ key: 'website', url: venue.website, icon: <WebsiteSvg /> });
  if (venue.tiktok) socials.push({ key: 'tiktok', url: venue.tiktok, icon: <TiktokSvg /> });
  if (venue.instagram) socials.push({ key: 'instagram', url: venue.instagram, icon: <InstagramSvg /> });
  if (venue.facebook) socials.push({ key: 'facebook', url: venue.facebook, icon: <FacebookSvg /> });

  if (socials.length === 0) return null;

  return (
    <motion.div
      data-testid="social-popup"
      initial="hidden"
      animate="visible"
      exit="hidden"
      variants={{
        hidden: { opacity: 0 },
        visible: {
          opacity: 1,
          transition: { staggerChildren: 0.06, delayChildren: 0.04, when: 'beforeChildren' },
        },
      }}
      style={{ position: 'absolute', left: 8, bottom: 60, zIndex: 30, display: 'flex', flexDirection: 'column', gap: 8 }}
    >
      {socials.map((social) => (
        <motion.button
          key={social.key}
          onClick={(event) => { event.stopPropagation(); window.open(social.url, '_blank'); }}
          data-testid={`social-${social.key}`}
          variants={{
            hidden: { opacity: 0, scale: 0.7, y: 14 },
            visible: { opacity: 1, scale: 1, y: 0 },
          }}
          transition={{ type: 'spring', stiffness: 420, damping: 24, mass: 0.5 }}
          whileHover={{ scale: 1.08 }}
          whileTap={{ scale: 0.9 }}
          style={{ width: 46, height: 46, borderRadius: 18, cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', border: 'none', ...actionButtonSurface }}
        >
          {social.icon}
        </motion.button>
      ))}
    </motion.div>
  );
}
